import React, { useState } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { closeDialog } from "@shared/store/dialog.duck";
import Dialog from '@shared/ui/molecules/Dialog';
import DialogHeader from '@shared/dialogs/DialogHeader';
import { LoadingOverlay } from '@shared/ui/molecules/LoadingOverlay';
import { PrimaryButton } from '@shared/ui/atoms/buttons/PrimaryButton';
import { selectAllTeams } from "@shared/store/config.duck";
import TeamMultiSelect from '@shared/ui/organisms/team-drop-down-list/TeamMultiSelect';
import { TeamEntity } from '@shared/models/team.models';
import styled from "styled-components";
import { clearSelectedDeskIds, selectSelectedDeskIds } from "../ducks/manageDesks.duck";
import { updateDeskOwnershipsForTeams } from "@features/desks/services/DeskOwnershipService";
import { successNotification } from "@shared/store/notification.duck";
import { fetchDesks } from "@features/desks/store/deskBooking.duck";
import { selectSelectedOffice } from "../../../store/officeView.duck";

export function AssignDesksToTeamDialog() {
  const dispatch = useDispatch();
  const allTeams = useSelector(selectAllTeams);
  const [teams, setTeams] = useState<TeamEntity[]>([]);
  const [loading, setLoading] = useState(false);
  const selectedDeskIds = useSelector(selectSelectedDeskIds);
  const selectedOffice = useSelector(selectSelectedOffice);

  const close = () => {
    dispatch(closeDialog())
  };

  const updateTagClick = async () => {
    setLoading(true);
    try {
      await updateDeskOwnershipsForTeams(selectedDeskIds, teams);
      dispatch(clearSelectedDeskIds());
      if (selectedOffice) {
        dispatch(fetchDesks(selectedOffice.id));
      }
      dispatch(successNotification('Desks assigned to team'))
      close();
    } finally {
      setLoading(false);
    }
  };

  const selectTeam = (teams: TeamEntity[]) => {
    setTeams(teams)
  }

  return (
    <DialogWrapper isOpen={true} onClose={close} showLogo={true}>
      <DialogHeader title="manage-desks-sidebar.assign-desks-to-team" />

      {loading && <LoadingOverlay />}

      <TeamMultiSelect onSelect={selectTeam}
                       teams={allTeams}
                       selectedTeams={teams}
                       disabled={loading} />

      <PrimaryButton disabled={loading}
                     fullWidth={true}
                     click={updateTagClick}
                     style={{marginTop: 'auto'}}
                     text="button.save-changes" />
    </DialogWrapper>
  )
}

const DialogWrapper = styled(Dialog)<any>`
  &.dialog {
    max-width: 100%;
    min-height: 410px;
  }
  .dialog__contentContainer, .dialog__content {
    width: 500px;
    min-height: 500px;
  }
  .dialog__content {
    display: flex;
    flex-direction: column;
  }
`
